import { createSelector } from 'reselect';
import { State } from 'store';

const getTransactionHandleBankState = (state: State) => state.transactions.handle.bank;

export const getBankTransactionHandleStatus = createSelector(
  getTransactionHandleBankState,
  bank => bank.status,
);
